import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DeletedAccount } from 'common/model/account/deletedAccount';
import { ClientAdminDeleteAccountsResponse } from 'common/model/client/clientAdminImpersonationListResponse';

export interface IDeletedAccountsSlice {
    deletedAccounts: DeletedAccount[];
    deleteAccountsLoading?: boolean;
    totalDeleteAccount?: number;
}

const initialState: IDeletedAccountsSlice = {
    deletedAccounts: [],
    deleteAccountsLoading: false,
};

export const deletedAccountsSlice = createSlice({
    name: '@@wh/deletedAccounts',
    initialState,
    reducers: {
        setSearchDeleteAccountsLoading(state, action: PayloadAction<IDeletedAccountsSlice['deleteAccountsLoading']>): void {
            state.deleteAccountsLoading = action.payload;
        },
        setSearchDeleteAccounts(state, action: PayloadAction<IDeletedAccountsSlice['deletedAccounts']>): void {
            state.deletedAccounts = action.payload;
        },
        setDeletedAccountsLoading(state, action: PayloadAction<IDeletedAccountsSlice['deleteAccountsLoading']>): void {
            state.deleteAccountsLoading = action.payload;
        },
        setDeletedAccounts(state, action: PayloadAction<ClientAdminDeleteAccountsResponse>): void {
            state.deletedAccounts = action.payload.data;
            state.totalDeleteAccount = action.payload.total;
        }
    }
});

export const {
    setSearchDeleteAccountsLoading,
    setSearchDeleteAccounts,
    setDeletedAccountsLoading,
    setDeletedAccounts,
} = deletedAccountsSlice.actions;
